import type { TfoOldScreeningStandard } from '@common/validation/customControls/ophthalmology';
import { Retinopathie } from '@common/validation/customControls/ophthalmology';

export function tfoConvertOldToNewScreeningStandard(value?: TfoOldScreeningStandard | null) {
    const oldToNew: Record<TfoOldScreeningStandard, Retinopathie> = {
        Ernstig: Retinopathie.r2,
        Geen: Retinopathie.r0,
        Gering: Retinopathie.r1,
        Matig: Retinopathie.r1,
        'Niet te beoordelen': Retinopathie.nietTeBeoordelen,
        'Zeer ernstig': Retinopathie.r2,
    };

    return value ? oldToNew[value] : null;
}
